var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDryerMachine1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 3.18006C0.75 2.35163 1.42157 1.68005 2.25 1.68005H21.75C22.5784 1.68005 23.25 2.35163 23.25 3.18005V21.7801C23.25 22.6085 22.5784 23.2801 21.75 23.2801H2.25C1.42157 23.2801 0.75 22.6085 0.75 21.7801V3.18006Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.4001C15.7279 20.4001 18.75 17.4989 18.75 13.9201C18.75 10.3413 15.7279 7.44006 12 7.44006C8.27208 7.44006 5.25 10.3413 5.25 13.9201C5.25 17.4989 8.27208 20.4001 12 20.4001Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 7.44011H19.035C17.1965 5.60037 14.6557 4.5603 12 4.5603C9.3443 4.5603 6.80353 5.60037 4.965 7.44011H0.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.20007C20.4571 4.20007 20.625 4.36125 20.625 4.56007C20.625 4.7589 20.4571 4.92007 20.25 4.92007C20.0429 4.92007 19.875 4.7589 19.875 4.56007C19.875 4.36125 20.0429 4.20007 20.25 4.20007",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42857 16.8C9.75198 16.1685 10.2048 14.7158 9.42857 13.9579C8.65239 13.2 9.10516 11.5369 9.42857 10.8",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 16.8C12.3233 16.1685 12.776 14.7158 11.9999 13.9579C11.2237 13.2 11.6765 11.5369 11.9999 10.8",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5711 16.8C14.8946 16.1685 15.3473 14.7158 14.5711 13.9579C13.795 13.2 14.2477 11.5369 14.5711 10.8",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryerMachine1);
export default __webpack_public_path__ + "static/media/dryer-machine-1.962df9ee.svg";
export { ForwardRef as ReactComponent };